// KAN-824: version + build stamp for the customer-facing portals.
//
// The operator ERP renders this into its sidebar footer (see App._renderBuildStamp). The portals are
// separate Workers with separate builds and had no version at all — so when a customer or a carrier
// reported a problem there was no way to know which build they were on.
//
// The tokens below are substituted at build time by the env-replacement plugin in each Vite config,
// all of which now derive them from the same place (build-id.js).

const APP_VERSION = '%VITE_APP_VERSION%';
const BUILD_ID    = '%VITE_BUILD_ID%';
const BUILD_TIME  = '%VITE_BUILD_TIME%';

// If a token was never substituted (a config that forgot to wire applyBuildTokens), we must not print
// a raw "%VITE_..." to a customer. Fall back to something harmless instead.
const sub = (v, fallback) => (typeof v === 'string' && !v.startsWith('%') ? v : fallback);

/**
 * Mount a small, muted "v1.6.1 · 3f63fb8" stamp in the corner of a portal.
 * Deliberately understated — these pages are customer-facing, so it must read as a quiet build
 * marker, not debug output.
 */
export function mountBuildStamp() {
  const version = sub(APP_VERSION, '');
  const build   = sub(BUILD_ID, 'dev');
  const built   = sub(BUILD_TIME, null);

  // Expose for support and smoke tests, mirroring the ERP.
  window.BUILD_ID = build;
  window.APP_VERSION = version;

  if (document.getElementById('build-stamp')) return;

  const el = document.createElement('div');
  el.id = 'build-stamp';
  el.className = 'build-stamp';
  el.textContent = version ? `${version} · ${build}` : build;
  el.title = `${version ? `Version ${version}\n` : ''}Build ${build}${built ? `\nBuilt ${built}` : ''}`;
  document.body.appendChild(el);
}
